import { useState } from 'react';

import { useDialog } from '@shared/hooks';

export const useHandleEstimateInformationModal = () => {
    const {
        isOpen: isOpenCreateEstimateModal,
        close: onCloseCreateEstimateModal,
        open: onOpenCreateEstimateModal,
    } = useDialog(false);

    const {
        isOpen: isOpenGanttModal,
        close: onCloseGanttModal,
        open: onOpenGanttModal,
    } = useDialog(false);

    const [isOpenAddEmployeesModal, setIsOpenAddEmployeesModal] = useState<
        'managers' | 'purchasers' | null
    >(null);

    const onHandleAddEmployeesModal = (value: 'managers' | 'purchasers' | null) => {
        setIsOpenAddEmployeesModal(value);
    };

    return {
        isOpenCreateEstimateModal,
        onCloseCreateEstimateModal,
        onOpenCreateEstimateModal,
        onHandleAddEmployeesModal,
        isOpenAddEmployeesModal,
        isOpenGanttModal,
        onCloseGanttModal,
        onOpenGanttModal,
    };
};
